// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SystemMessage } from '@interfaces/document.interfaces';
import { AppEvent } from '@interfaces/interfaces';

@Component({
    selector: 'system-message-modal',
    templateUrl: './system-message-modal.component.html',
    styleUrls: ['./system-message-modal.component.scss'],
})
export class SystemMessageModalComponent implements OnInit {
    public systemMessageData: SystemMessage = undefined;

    constructor(
        private dialogRef: MatDialogRef<SystemMessageModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.systemMessageData = this.data.systemMessageData;
    }

    public closeModal() {
        this.dialogRef.close();
    }
}
